import React from "react";
import useTranslation from "../../../hooks/useTranslation";
import { Skeleton } from "@mui/material";

const UserFeedSkeleton = () => {
  const { t } = useTranslation();
  return (
    <div className="w-full hidden lg:block bg-white rounded-[30px] py-[34px] px-[33px] border border-[#C1C1C1]">
      <div className="flex flex-col h-full">
        <div className="flex flex-col items-center gap-4 border-b-[0.5px] border-[#923FB34A] pb-3">
          <div className="w-16 h-16 bg-[#E7D5EEB8] rounded-full flex justify-center items-center">
            <Skeleton className="w-full h-full" variant="circular" />
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="flex flex-row gap-3">
              <Skeleton className="w-14" />
              <Skeleton className="w-14" />
            </div>
            <span className="text-primary font-MyriadPro text-sm tracking-widest hidden lg:block my-3 px-6 py-1 rounded-full bg-[#F7EFFA] ">
              <Skeleton className="w-16" />
            </span>
          </div>
        </div>
        <div className="flex flex-col gap-2  pt-3">
          <div className="w-full flex justify-between items-center text-sm tracking-widest text-black">
            <span className="capitalize">{t("service succès")}</span>
            <span className="font-semibold capitalize flex gap-2">
              <div className="">
                <Skeleton className="w-3" />
              </div>
              {t("services")}
            </span>
          </div>
          <div className="w-full flex justify-between items-center text-sm tracking-widest text-black">
            <span>{t("Rating")}</span>
            <div className="flex items-center gap-1">
              <img src="/svg/star.svg" alt="star" />
              <Skeleton className="w-3" />
            </div>
          </div>
          <div className="w-full flex justify-between items-center text-sm tracking-widest text-black">
            <span>{t("Member depuis")}</span>
            <Skeleton className="w-16" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFeedSkeleton;
